import { Link, Path } from 'react-router-dom';
import slugify from 'slugify';

import { useTracking } from 'hooks';

import Styles from './TextLink.styles';

type TextLinkProps = {
  label: string;
  to: string | Partial<Path>;
  section: string;
  target?: '_blank' | '_self';
  fontSize?:
    | 'bodyLargeStandard'
    | 'bodyLargeShort'
    | 'bodySmallStandard'
    | 'bodySmallShort'
    | 'exceptionsAuxiliar'
    | 'exceptionsRestricted';
  fontWeight?: 'bold' | 'regular' | 'medium';
};

export const TextLink = ({
  label,
  to,
  section,
  fontSize,
  fontWeight,
  target = '_blank',
}: TextLinkProps) => {
  const { sendDataToGTM } = useTracking();

  const handleTracking = () => {
    sendDataToGTM({
      event: 'analytics-event',
      event_parameters: {
        event_name: `interaction_${slugify(section, {
          lower: true,
          replacement: '-',
        })}`,
        cd_interaction_detail: `click:${slugify(label, {
          lower: true,
          replacement: '-',
        })}`,
      },
    });
  };
  return (
    <Link to={to} target={target} rel='noopener noreferrer'>
      <Styles.Text
        onClick={handleTracking}
        color='$linkDefault'
        fontWeight={fontWeight}
        fontSize={fontSize}
        textDecoration='underline'
      >
        {label}
      </Styles.Text>
    </Link>
  );
};
